import { Component, HostListener, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Floating "back to top" button for listing pages. Appears once the page has
 * scrolled more than two screen-heights down.
 */
@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  template: `
    @if (visible) {
      <button type="button" (click)="scrollToTop()"
        class="fixed bottom-6 right-6 z-50 flex items-center justify-center w-11 h-11 rounded-full bg-[#D31148] text-white shadow-lg hover:bg-[#b80e3d] active:scale-90 transition-all duration-200"
        aria-label="Back to top">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 15l-6-6-6 6" />
        </svg>
      </button>
    }
  `,
})
export class ScrollToTop {
  private platformId = inject(PLATFORM_ID);

  visible = false;

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.visible = window.scrollY > window.innerHeight * 2;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
